import { render, staticRenderFns } from "./MultipleOption.vue?vue&type=template&id=d84c4046"
import script from "./MultipleOption.vue?vue&type=script&lang=js"
export * from "./MultipleOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports